
/* injects from baggage-loader */

'use strict';

import ProductGroupSettingsComponent from './product-group.settings.component';

const ProductGroupSettingsPageModule = angular.module('product-group-settings-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('product-group.settings', {
        url: '/settings',
        component: 'productGroupSettings',
        data: {
          title: 'Settings'
        }
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('productGroupSettings', new ProductGroupSettingsComponent());

export default ProductGroupSettingsPageModule;
